import {SimplePresentation, SimplePresentationRunnerController} from "../../../SimplePresentationRunner";
import {XwaysHoarder2} from "../../../XwaysHoarder2";
import {gsap} from "gsap";
import {LTSymbol} from "../../../reels/symbols/LTSymbol";
import {XwaysHoarder2Sound} from "../../../sound/XwaysHoarder2Sound";


export class LootRespinEnd implements SimplePresentation {
    name: string = "LootRespinEnd";

    shouldRun(): boolean {
        return XwaysHoarder2.model.data.nextRespinIsTheLastReSpin;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline();
        controller.setSkipCallback();

        const LTsym: LTSymbol = <LTSymbol>XwaysHoarder2.reelView.reels[0].model.LTarray[0].positionable;
        XwaysHoarder2.reelView.reels[0].makeLTfirstSymbolOfReel(LTsym,0,false);
        tl.add(LTsym.playLTLightSpineAnimation("LootLightLoop", false));
        tl.add(() => {
            LTsym.moveToNormalLayer();
        });


        tl.add(() => {
            XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.RESPIN_ALARM);
            controller.finish();
        });
    }


}